import type { AuthUser } from '@/lib/api';

export function isSuperAdmin(user: Pick<AuthUser, 'role'> | null | undefined): boolean {
  return user?.role === 'SUPER_ADMIN';
}
